module.exports = __webpack_public_path__ + "static/computer_icon-ec7165857e132f96fe0f0535e7ecec62.svg";